import React from 'react';
import { Paper } from '@mui/material';
import Loading from 'src/components/baseComponents/Loading';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import innerStyles from './index.module.scss';
import clsx from 'clsx';

const styles = { ...innerStyles };

const formatMarkdownText = (text) => {
  if (!text) return '';

  return text.replace(
    /(file=)([^)]*?)(#page=\d+)/g,
    (match, prefix, fileName, suffix) => {
      const encodedFileName = fileName.replace(/\s/g, '%20');
      return `${prefix}${encodedFileName}${suffix}`;
    },
  );
};

const ChatMessage = ({ message }) => {
  return (
    <>
      {(message?.text || message?.loading) && (
        <>
          <Paper
            elevation={2}
            className={clsx(
              message?.role === 'user'
                ? styles.userChatMessage
                : styles.assistantChatMessage,
            )}
          >
            {message?.loading && <Loading hideCircle={true} dots />}
            {!message?.loading && (
              <p>
                <Markdown
                  remarkPlugins={[remarkGfm]}
                  components={{
                    a: ({ node, children, ...props }) => (
                      <a {...props} target='_blank' rel='noopener noreferrer'>
                        {children}
                      </a>
                    ),
                  }}
                >
                  {formatMarkdownText(message?.text)}
                </Markdown>
              </p>
            )}
          </Paper>
        </>
      )}
    </>
  );
};

export default ChatMessage;
